export default "__VITE_ASSET__2jRCkVCS__"